import * as React from 'react';
import "./order-details.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useState } from 'react';
import moment, { now } from 'moment';
import { updateOrder, getTripById,getUserProfile , markTripCompleted } from '../../shared/api/user';
import { useParams } from "react-router-dom";
import { getSingleOrder } from '../../shared/api/user';
import { useEffect } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { getMe } from '../../shared/api/user';
import {  Dialog,  DialogTitle,  DialogContent,  DialogActions,  TextField,MenuItem,} from "@mui/material";


export default function BasicTable() {
    const [orders, setOrders] = useState([]);
    const [trip, setTrip] = useState([]);
    const [dishes, setDishes] = useState([]);
    const [addons, setAddons] = useState([]);
    const { id } = useParams();
    const [showMap, setShowMap] = useState(false);
    const [receiverInfo, setReceiverInfo] = useState(null);
    const [cancelReason, setCancelReason] = useState("");
    const currencySymbol = orders?.orderFrom === 'US' ? '$' : 'Rs.';
    const [openCancelDialog, setOpenCancelDialog] = useState(false);        
    const [otherReason, setOtherReason] = useState("");

    const cancelReasons = [
    "User didn’t pick the call.",
    "Items are not available.",
    "Fake phone number.",
    "Customer requested to cancel due to personal reasons.",
    "Restaurant is closed.",
    "Test order.",
    "Other",
    ];

    const init = async () => {
        let rows = await getSingleOrder(id);
        setOrders(rows.data.order);
        getTripDetails(rows.data.order.tripId);
        // Fetch receiver profile if receiver exists
        console.log('id',rows.data.order.receiver)
        if (rows.data.order.receiver) {
            const receiverRes = await getUserProfile(rows.data.order.receiver);
            console.log(receiverRes)
            setReceiverInfo(receiverRes.data.user[0]);
        }
        
        let dishes = [];
        let addons = [];
        setDishes(dishes)
        rows.data.order.orderItems.forEach((e => {
            e.dish.quantity = e.quantity;
            e.dish.specialInstructions=e.specialInstructions;
            if (e.dish.price === 0 || e.dish.price === null) {
                e.size.forEach((s => {
                    e.dish.sizes.forEach((size => {
                        if (s.size === size._id) {
                            size.quantity = s.quantity;
                            size.crust = s.crust;
                            size.flavour = s.flavour;
                            size.sauce = s.sauce;
                            size.dish = e.dish;                            
                            dishes.push(size)
                        }
                    }))
                }))
            } else {
                dishes.push(e.dish);
            }
            console.log(dishes)
        }))
        rows.data.order.orderItems.forEach((e => {
            e.addons.forEach((a => {
                e.dish.addons.forEach((addon => {
                    if (a.addon === addon._id) {
                        addon.quantity = a.quantity;
                        addons.push(addon);
                    }
                }))
            }))
        }))
        setAddons(addons)
    }

    const getTripDetails = async (tripId) => {
        if (tripId) {
            let trip = await getTripById(tripId);
            setTrip(trip);
        }
    }

    const refreshDriverLocation = async () => {
    if (trip?._id) {
        let updatedTrip = await getTripById(trip._id);
        setTrip(updatedTrip);
    }
};

    const toggleMap = () => {
    setShowMap(!showMap);
    };



    const broadcastTripById = async (tripId) => {
        let trip = await broadcastTrip(tripId);
    }

    useEffect(() => {
        init();
    }, []);

    async function updateOrderDetails(id,reason) {
        let user = await getMe();        
        await updateOrder(id, { 
            orderStatus: 'CANCELLED', 
            cancelledBy: user.data.user.firstName +' '+ user.data.user.lastName,
            cancelledAt: new Date().toISOString(),
            cancellationReason: reason || "",
        }
        );
        init();
    }

    async function markCompleted(id) {
        // await markTripCompleted(id);
        // init();
    }
let total = 0;

if (currencySymbol === "Rs.") {
  total =
    orders.subTotal +
    orders?.couponDiscount +
    orders.walletAmount +
    orders.nintyNineDiscount +
    orders.serviceFee;
} else {
  total =    orders.subTotal +orders?.couponDiscount -orders.walletAmount + orders.deliveryCharges + orders.serviceFee;
}

    return (
        <div>
            <div className='items-details'>
                <TableContainer className='table-container' sx={{ minWidth: 550, maxWidth: 700 }} component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead className='table-head'>
                            <TableRow>
                                <TableCell className='table-call-row'>Dish Name</TableCell>
                                <TableCell className='table-call-row' align="right">Quantity</TableCell>
                                <TableCell className='table-call-row' align="right">Description</TableCell>
                                <TableCell className='table-call-row' align="right">Special Instructions</TableCell>
                                <TableCell className='table-call-row' align="right">Size</TableCell>
                                <TableCell className='table-call-row' align="right">Flavour</TableCell>
                                <TableCell className='table-call-row' align="right">Crust</TableCell>
                                <TableCell className='table-call-row' align="right">Sauce</TableCell>
                                <TableCell className='table-call-row' align="right">Price</TableCell>
                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dishes.map((row) => {
    // console.log('Row data:', row); // Add this to see the actual structure
    // console.log('Special instructions:', row.specialInstructions); // Check this value
    
    return (
                                <TableRow
                                    key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    {!row.size && <TableCell className='table-call-row-data' component="th" scope="row">{row.dishName.substring(0, 45)}...</TableCell>}
                                    {row.size && <TableCell className='table-call-row-data' component="th" scope="row">{row.dish.dishName.substring(0, 45)}...</TableCell>}
                                    {/* {row.size && <TableCell className='table-call-row-data' align="center">{row.size}</TableCell>} */}
                                    {/* {row.offers && <TableCell className='table-call-row-data' align="center">{row.quantity * 2}</TableCell>} */}
                                    {!row.offers && <TableCell className='table-call-row-data' align="center">{row.quantity}</TableCell>}
                                    {!row.size && <TableCell className='table-call-row-data' align="right">{row.description.substring(0, 65)}...</TableCell>
                                    }
                                    {row.size && <TableCell className='table-call-row-data' align="right">{row.dish.description.substring(0, 65)}...</TableCell>
                                    }
                                    <TableCell className='table-call-row-data' align="left">
                                        {row.specialInstructions ? row.specialInstructions.substring(0, 100) + (row.specialInstructions.length > 100 ? '...' : '') : 'No special instructions'}
                                    </TableCell>
                                    {row.size && <TableCell className='table-call-row-data' align="center">{row.size}</TableCell>}
                                    {row.size && <TableCell className='table-call-row-data' align="center">{row.flavour}</TableCell>}
                                    {row.size && <TableCell className='table-call-row-data' align="center">{row.crust}</TableCell>}
                                    {row.size && <TableCell className='table-call-row-data' align="center">{row.sauce}</TableCell>}
                                    <TableCell className='table-call-row-data' align="right">Rs. {row.price}</TableCell>
                                    
                                </TableRow>
                           );
  })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TableContainer className='table-container' sx={{ mt: 3, minWidth: 550, maxWidth: 700 }} component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead className='table-head'>
                            <TableRow>
                                <TableCell className='table-call-row'>Addon Name</TableCell>
                                <TableCell className='table-call-row' align="right">Quantity</TableCell>
                                <TableCell className='table-call-row' align="right">Description</TableCell>
                                <TableCell className='table-call-row' align="right">Addon Price</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {addons.map((row) => (
                                <TableRow
                                    key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className='table-call-row-data' component="th" scope="row">{row.addonName}</TableCell>
                                    <TableCell className='table-call-row-data' align="right">{row.quantity}</TableCell>
                                    <TableCell className='table-call-row-data' align="right">{orders.description}</TableCell>
                                    <TableCell className='table-call-row-data' align="right">Rs. {row.addonPrice}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div>
                <div className='pricingdel'>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className='title-details'>Order Details</div>
                        {orders.orderStatus !== 'COMPLETED' && orders.orderStatus !== 'CANCELLED' && <Button
                        onClick={() => setOpenCancelDialog(true)}
                        sx={{
                          mb: 2,
                          color: '#CB2704',
                          fontWeight: '600',
                          border: '1px solid #CB2704',
                          "&:hover": { border: "1px solid red" },
                        }}
                        variant="outlined"
                        style={{ float: "right" }}
                        startIcon={<ClearIcon sx={{ color: '#CB2704' }} />}
                      >
                        Cancel Order
                      </Button>}
                        {/* {orders.orderStatus !== 'COMPLETED' && <Button onClick={() => markCompleted(id)} sx={{ mb: 2, color: '#CB2704', fontWeight: '600', border: '1px solid #CB2704', "&:hover": { border: "1px solid red" } }} variant="outlined" style={{ float: "right" }} startIcon={<ClearIcon sx={{ color: '#CB2704' }} />}>
                            Mark Completed
                        </Button>} */}
                    </div>
                    <div className='total-flex'>
                        <div><b>Customer Name</b></div>
                        {/* <div>{orders.user?.firstName} {orders.user?.lastName}</div> */}
                        {orders?.user?.firstName ? `${orders?.user?.firstName} ${orders?.user?.lastName || ''}` : orders?.customerName || 'N/A'}
                    </div>
                    <div className='total-flex'>
                        <div><b>Customer Phone</b></div>
                        <div>{orders.user?.phoneNumber}</div>
                        {orders?.user?.phoneNumber ? `${orders?.user?.phoneNumber} || ''}` : orders?.customerPhone || 'N/A'}
                    </div>
                    <div className='total-flex'>
                        <div><b>Customer Email</b></div>
                        <div>{orders.user?.email}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Restaurant Name</b></div>
                        <div>{orders.chef?.restaurantName}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Restaurant Phone</b></div>
                        <div>{orders.chef?.phoneNumber}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Restaurant Email</b></div>
                        <div>{orders.chef?.email}</div>
                    </div>
                    {orders.orderType === 'DELIVERY' && <div className='total-flex'>
                        <div><b>Driver Name</b></div>
                        <div>{`${trip?.driver?.firstName} ${trip?.driver?.lastName}`}</div>
                    </div>}
                    {orders.orderType === 'DELIVERY' && <div className='total-flex'>
                        <div><b>Driver Phone Number</b></div>
                        <div>{trip?.driver?.phoneNumber}</div>
                    </div>}
                    <div className='total-flex'>
                        <div><b>Order Time</b></div>
                        <div>{moment(orders.createdAt).format('MMMM Do YYYY, h:mm a')}</div>
                    </div>                    
                    {orders?.orderStatusTimeStamps?.acceptedAt &&
                        <div className='total-flex'>
                            <div><b>Order Accepted at</b></div>
                            <div>{moment(orders?.orderStatusTimeStamps?.acceptedAt).format('MMMM Do YYYY, h:mm a')}</div>
                        </div>
                    }
                    {orders.orderStatus  === 'COMPLETED' && <div className='total-flex'>
                        <div><b>Order Completed at</b></div>
                        <div>{moment(orders.updatedAt).format('MMMM Do YYYY, h:mm a')}</div>
                    </div>
                    }
                    {orders?.orderStatusTimeStamps?.inProgressAt &&
                        <div className='total-flex'>
                            <div><b>Order In Progress at</b></div>
                            <div>{moment(orders?.orderStatusTimeStamps?.inProgressAt).format('MMMM Do YYYY, h:mm a')}</div>
                        </div>
                    }
                    {orders?.orderStatusTimeStamps?.completedAt &&
                        <div className='total-flex'>
                            <div><b>Order Completed at</b></div>
                            <div>{moment(orders?.orderStatusTimeStamps?.completedAt).format('MMMM Do YYYY, h:mm a')}</div>
                        </div>
                    }
                    {orders?.orderStatusTimeStamps?.cancelledAt &&
                        <div className='total-flex'>
                            <div><b>Order Cancelled at</b></div>
                            <div>{moment(orders?.orderStatusTimeStamps?.cancelledAt).format('MMMM Do YYYY, h:mm a')}</div>
                        </div>
                    }
                    <div className='total-flex'>
                        <div><b>Order Status</b></div>
                        <div>{orders.orderStatus}</div>
                    </div>
                    {  orders.orderStatus === 'CANCELLED' && (
                    <div className='total-flex'>
                        <div><b>Cancelled By</b></div>
                        <div>{orders.cancelledBy}</div>
                    </div>)}
                    {  orders.orderStatus === 'CANCELLED' && (
                    <div className='total-flex'>
                        <div><b>Cancellation Reason</b></div>
                        <div>{orders.cancellationReason}</div>
                    </div>)}

                    {orders.orderType === 'DELIVERY' && <div className='total-flex'>
                        <div><b>Trip Status</b></div>
                        <div>{trip.status}</div>
                    </div>}
                    {orders.orderType === 'DELIVERY' && <div className='total-flex'>
                        <div><b>Est Cooking Time</b></div>
                        <div>{orders.estTime} Minutes</div>
                    </div>}
                    {orders.orderType === 'DELIVERY' && orders.orderStatus === 'COMPLETED' && <div className='total-flex'>
                        <div><b>Feedback</b></div>
                        <div>{orders?.feedback?.message}</div>
                    </div>}
                    {orders.orderType === 'DELIVERY' && orders.orderStatus === 'COMPLETED' && <div className='total-flex'>
                        <div><b>Rating</b></div>
                        <div>{orders?.feedback?.rating}⭐</div>
                    </div>}
                    <div className='total-flex'>
                        <div><b>Order Type</b></div>
                        <div>{orders.orderType}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Payment Status</b></div>
                        <div>{orders.paymentStatus}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Payment By</b></div>
                        <div>{orders.paymentBy}</div>
                    </div>
                    {orders.orderFrom === "PK" && (
                    <div className='total-flex'>
                        <div><b>Source Address</b></div>
                        <div>{trip.sourceAddress}</div>
                    </div>
                    )}
                    {orders.orderFrom === "PK" && (
                    <div className='total-flex'>
                        <div><b>Destination Address</b></div>
                        {/* <div>{trip.destinationAddress}</div> */}
                         <div>
                            {Array.isArray(trip?.destination)
                                ? trip.destination.map((dest, index) => (
                                    <div key={index}>{dest.address}</div>
                                ))
                                : trip?.destinationAddress || "N/A"}
                            </div>
                    </div>
                    )}
                    <div className='total-flex'>
                        <div><b>Order From Country</b></div>
                        <div>{orders.orderFrom}</div>
                    </div>
                    <div className='total-flex'>
                    <div><b>Receiver Name</b></div>
                    <div>
                        {receiverInfo
                            ? `${receiverInfo.firstName} ${receiverInfo.lastName}`
                            : orders?.receiver}
                    </div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Receiver Phone</b></div>
                        <div>{orders?.receiverPhone || "N/A"}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Receiver Address</b></div>
                        <div>{orders?.receiverAddress || "N/A"}</div>
                    </div>

                    <div className='total-flex'>
                        <div><b>Special Notes</b></div>
                        <div>{trip?.specialNotes}</div>
                    </div>


                    <div className='total-flex'>
                        <div><b>Sub Total</b></div>
                        <div>{currencySymbol} {(orders?.subTotal+.001).toFixed(2)}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Service Fee & Other Charges</b></div>
                        <div>{currencySymbol} {orders.chefServiceFee}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Restaurant Service Fee Percentage</b></div>
                        <div>{orders?.chef?.customServiceFee}%</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Discount</b></div>
                        <div><b>{currencySymbol} {(orders.couponDiscount)}</b></div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Wallet Money Discount</b></div>
                        <div><b>{currencySymbol} {(orders.walletAmount)}</b></div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Ninty Nine Offer Discount</b></div>
                        <div><b>Rs. {(orders.nintyNineDiscount)}</b></div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Delivery Fee</b></div>
                        <div><b>{currencySymbol} {(orders.deliveryCharges)}</b></div>
                    </div>

                    <div className='total-flex'>
                        <div><b>Service Fee</b></div>
                        <div><b>{currencySymbol} {(orders.serviceFee)}</b></div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Total</b></div>
                        {/* <div><b>{currencySymbol}  {(orders.subTotal + orders?.couponDiscount + orders.walletAmount + orders.nintyNineDiscount + orders.serviceFee).toFixed(2)}</b></div> */}
                        {/* <b>{currencySymbol} {total.toFixed(2)}</b> */}
                        {total > 0 ? (
                            <b>{currencySymbol} {total.toFixed(2)}</b>
                            ) : (
                            <b>{currencySymbol} {orders?.total}</b>
                            )}
                    </div>
                    <div className='total-flex'>
                        <div><b>Pay to Restaurant</b></div>
                        {/* <div><b>Rs. {(((orders?.subTotal + orders?.couponDiscount + orders.nintyNineDiscount) * `0.${orders?.chef?.customServiceFee}`) - (orders?.subTotal + orders?.couponDiscount + orders.nintyNineDiscount))}</b></div> */}
                    </div>
                    {/* <div className='total-flex'>
                        <div><b>Pay to Restaurant</b></div>
                        <div><b>Rs. {(((orders.subTotal + orders?.couponDiscount) * `0.${orders?.chef?.customServiceFee}`) - orders.subTotal)}</b></div>
                    </div> */}
                    <div className='total-flex'>
                        <div><b>Order Notes</b></div>
                        <div>{orders.notes}</div>
                    </div>
                    <div className='total-flex'>
                        <div><b>Vendor Delivery</b></div>
                        {orders?.chef?.isVendorDelivery && <div>True</div>}
                        {!orders?.chef?.isVendorDelivery && <div>False</div>}
                    </div>
                    
                    {orders.orderType === 'DELIVERY' && <div className='total-flex'>
                        <div><b>Trip Id</b></div>
                        <div>{trip?._id}</div>
                    </div>}
                    {orders.orderType === 'DELIVERY' && <div className='total-flex'>
                        <div><b>Trip Cancelled At</b></div>                        
                        <div>{moment(trip?.tripCancelledAt).format('MMMM Do YYYY, h:mm a')}</div>
                    </div>}

                    <div className='total-flex'>
                        <div><b>Customer Id</b></div>
                        <div>{orders?.user?._id}</div>
                    </div>

                    <div className='total-flex'>
                        <div><b>Restaurant Id</b></div>
                        <div>{orders?.chef?._id}</div>
                    </div>

                    <div className='total-flex'>
                        <div><b>Order Id</b></div>
                        <div>{orders?._id}</div>
                    </div>

                    {orders.orderType === 'DELIVERY' && <div className='total-flex'>
                        <div><b>Driver Id</b></div>
                        <div>{trip?.driver?._id}</div>
                    </div>}

                    <div className='total-flex'>
                        <div><b>Driver Photo</b></div>
                        <div><img src={trip?.driver?.profileImgUrl} alt="ForunPoint" height={150} />
                        </div>
                    </div>
                     {/* MAP         */}
                    {/* {orders.orderType === 'DELIVERY' && trip?.driver?.currentLocation?.coordinates && ( */}
                    { trip?.driver?.currentLocation?.coordinates && (
                        <div style={{ 
                            marginTop: '20px', 
                            display: 'flex', 
                            justifyContent: 'center', 
                            flexDirection: 'column', 
                            alignItems: 'center',
                            width: '100%' 
                        }}>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                <Button 
                                    variant="contained" 
                                    onClick={toggleMap}
                                    sx={{
                                        backgroundColor: '#4285F4',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: '#3367D6'
                                        }
                                    }}
                                >
                                    {showMap ? 'Hide Map' : 'View Driver Location'}
                                </Button>
                                
                                {showMap && (
                                    <Button 
                                        variant="contained" 
                                        onClick={refreshDriverLocation}
                                        sx={{
                                            backgroundColor: '#34A853',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: '#2D8E47'
                                            }
                                        }}
                                    > 
                                        Refresh Location
                                    </Button>
                                )}
                            </div>
                            
                            {showMap && (
                                <div style={{ 
                                    width: '100%', 
                                    maxWidth: '800px', 
                                    height: '400px', 
                                    position: 'relative',
                                    overflow: 'hidden'
                                }}>
                                    <iframe
                                        key={`${trip.driver.currentLocation.coordinates[0]}-${trip.driver.currentLocation.coordinates[1]}`}
                                        width="100%"
                                        height="100%"
                                        style={{ 
                                            border: 'none',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0
                                        }}
                                        loading="lazy"
                                        allowFullScreen
                                        referrerPolicy="no-referrer-when-downgrade"
                                        src={`https://maps.google.com/maps?q=${trip.driver.currentLocation.coordinates[0]},${trip.driver.currentLocation.coordinates[1]}&z=15&output=embed&iwloc=near`}>
                                    </iframe>
                                </div>
                            )}



    </div>
)}
                            <Dialog open={openCancelDialog} onClose={() => setOpenCancelDialog(false)}>
  <DialogTitle>Cancel Order</DialogTitle>
  <DialogContent>
    {/* Dropdown for reason selection */}
    <TextField
      select
      margin="dense"
      label="Cancellation Reason"
      fullWidth
      value={cancelReason}
      onChange={(e) => setCancelReason(e.target.value)}
    >
      {cancelReasons.map((reason, index) => (
        <MenuItem key={index} value={reason}>
          {reason}
        </MenuItem>
      ))}
    </TextField>

    {/* Show text field only if "Other" selected */}
    {cancelReason === "Other" && (
      <TextField
        margin="dense"
        label="Please specify"
        type="text"
        fullWidth
        multiline
        rows={3}
        value={otherReason}
        onChange={(e) => setOtherReason(e.target.value)}
      />
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenCancelDialog(false)} color="inherit">
      Close
    </Button>
    <Button
      onClick={async () => {
        const finalReason =
          cancelReason === "Other"
            ? otherReason.trim()
            : cancelReason.trim();

        if (!finalReason) {
          alert("Please select or enter a cancellation reason.");
          return;
        }

        await updateOrderDetails(id, finalReason);
        setOpenCancelDialog(false);
        setCancelReason("");
        setOtherReason("");
      }}
      color="error"
      variant="contained"
    >
      Save
    </Button>
  </DialogActions>
</Dialog>
                </div>
            </div>
        </div>

        
    );
}